import moment from "moment";

import {
    getSaved,
    getRecent,
    getCategories,
    getRecurring,
    getHistory,
} from "../../api/billsPayments/billsPaymentsService";

/**
 * State for Bill Payments
 */
export const state = () => ({
    categories: [],
    recentPayments: [],
    savedPayments: [],
    recurringPayments: [],
    historyPayments: [],
    // loading states
    isFetchingCategories: true,
    isFetchingRecent: true,
    isFetchingSaved: true,
    isFetchingRecurring: true,
    isFetchingHistory: true,
})

/**
 * Getters for Bill Payments
 */
export const getters = {
    recentPaymentsSublist: (state) => {
       return state.recentPayments
    },
    isRecentEmpty: (state) => {
        return state.recentPayments.length === 0 && !state.isFetchingRecent
    },
    isCategoriesEmpty: (state) => {
        return state.categories.length === 0 && !state.isFetchingCategories
    },
    isSavedEmpty: (state) => {
        return state.savedPayments.length === 0 && !state.isFetchingSaved
    },
    isRecurringEmpty: (state) => {
        return state.recurringPayments.length === 0 && !state.isFetchingRecurring
    },
    isHistoryEmpty: (state) => {
        return state.historyPayments.length === 0 && !state.isFetchingHistory
    },
    rangeHistory: (state) => (startDate, endDate) => {
        return state.historyPayments.filter(item => {
            let compareDate = moment(item.createdAt);
            return compareDate.isBetween(startDate, endDate)
        })
    }
}

/**
 * Mutations for Bill Payments
 */
export const mutations = {
    setLoadState(state, payload) {
        state[payload.key] = payload.value
    },
    setCategories(state, payload) {
        state.categories = payload.value
    },
    setRecent(state, payload) {
        state.recentPayments = payload.value
    },
    setSaved(state, payload) {
        state.savedPayments = payload.value
    },
    setRecurring(state, payload) {
        state.recurringPayments = payload.value
    },
    setHistory(state, payload) {
        state.historyPayments = payload.value
    },
    updateRecent(state, payload) {
        state.recentPayments.push(payload.value)
    },
    updateSaved(state, payload) {
        state.savedPayments.push(payload.value)
    },
    updateRecurring(state, payload) {
        state.recurringPayments.push(payload.value)
    },
    updateHisory(state, payload) {
        state.historyPayments.push(payload.value)
    },
}

/**
 * Actions for Bill Payments
 */
export const actions = {
    async fetchCategories({ commit, dispatch }) {
        try {
            commit('setLoadState', { key: 'isFetchingCategories', value: true })
            const { response: { data } }  = await getCategories()
            commit('setCategories', { value: data.content })
        } catch (error) {
            dispatch('handleError', { response: error }, {root: true})
        } finally{
            commit('setLoadState', { key: 'isFetchingCategories', value: false })
        }
    },
    async fetchRecent({ commit, dispatch }) {
        try {
            commit('setLoadState', { key: 'isFetchingRecent', value: true })
            const { response: { data } }  = await getRecent(30)
            commit('setRecent', { value: data })
        } catch (error) {
            dispatch('handleError', { response: error }, {root: true})
        } finally {
            commit('setLoadState', { key: 'isFetchingRecent', value: false })
        }
    },
    async fetchSaved({ commit, dispatch }) {
        try {
            commit('setLoadState', { key: 'isFetchingSaved', value: true })
            const { response: { data }} = await getSaved()
            commit('setSaved', { value: data.content })
        } catch (error) {
            dispatch('handleError', { response: error }, {root: true})
        } finally {
            commit('setLoadState', { key: 'isFetchingSaved', value: false })
        }
    },
    async fetchRecurring({ commit, dispatch }) {
        try {
            commit('setLoadState', { key: 'isFetchingRecurring', value: true })
            const { response: { data }} = await getRecurring()
            commit('setRecurring', { value: data.content })
        } catch (error) {
            dispatch('handleError', { response: error }, {root: true})
        } finally {
            commit('setLoadState', { key: 'isFetchingRecurring', value: false })
        }
    },
    async fetchHistory({ commit, dispatch }, payload) {
        try {
            commit('setLoadState', { key: 'isFetchingHistory', value: true })
            const { response: { data }} = await getHistory(payload.value)
            commit('setHistory', { value: data.content })
        } catch (error) {
            dispatch('handleError', { response: error }, {root: true})
        } finally {
            commit('setLoadState', { key: 'isFetchingHistory', value: false })
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
